// video call connection status
export const ConnectionStatus = Object.freeze({
    IN_PROGRESS : 'inprogress',
    CONNECTED : 'connected',
    DISCONNECTED : 'disconnected',
});

// message types
export const MESSAGE_TYPE = Object.freeze({
    TEXT: 'text',
    ATTACHMENT: 'attachment',
    URL: 'url' // not in use currently
})

// image types
export const ATTACHMENT_IMAGE_TYPES = [
    'png',
    'jpeg',
    'gif',
    'jpg'
]
// file types
export const ATTACHMENT_FILE_TYPE = [
    'pdf',
    'docx',
    'doc',
    'exe'
]


// WEBPACK FOOTER //
// ./src/util/common.js